/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '../../api.service';
import { Meta, Title } from '@angular/platform-browser';
import { PopupService } from 'src/app/services/popup.service';
import { Location, isPlatformBrowser } from '@angular/common';
import { fadeimagesInOut } from 'src/app/animations';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  animations:[fadeimagesInOut]
})
export class ListComponent implements OnInit {
  global_loader = true;
  main_category_list: any[] = [];
  activeDpId: any;
  brand_list: any[] = [];
  totalBrands: any;
  showCatTypePopUp = false;
  selectedBrand: any;
  ctatype_list: any;
  showCatTypeMobPopUp = false;
  is_brand_loading = false;
  page_load = false;
  category_list_string!: string;
  constructor(@Inject(PLATFORM_ID) private platformId: object,private _ar: ActivatedRoute, public _as: AppService, private _router: Router, public title: Title,private meta:Meta, public _pop: PopupService,public _location:Location) { }

  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)){
      this.getDepartment();
    }
   

  }
  getDepartment() {
    setTimeout(() => {
      this.page_load = true;
    }, 5);
    const url = this._as.api_base_url + 'staff/categorys/';
    this._as.getRequest(url, false)
      .subscribe((res: any) => {
        this.main_category_list = res.data;
        // this.global_loader = false;
        this.onDepartment(undefined)
        const category_list = [];
        for (const pro of this.main_category_list) {
          category_list.push(pro.name)
        }
        this.category_list_string = String(category_list);
        this.setSeoData();
      }, (err: any) => {
        if (err) {
          this.global_loader = false;
        }
      });
  }
  setSeoData(){
    this.title.setTitle('Explore a diverse array of top, trending & promising interior products brands.');
    this.meta.addTags([
      {
        name: 'keywords',
        content:'Interior material & products brands',
      },
      { name: 'robots', content: 'index, follow' },
      { charset: 'UTF-8' },
    ]);
    const image_link = this._as.site_url+'/assets/images/afterbrikcs-brands.webp';
    this.meta.updateTag({property: 'og:title', content:'Explore a diverse array of top, trending & promising interior products brands.'});
  this.meta.updateTag({property: 'og:image', content: image_link});
  this.meta.updateTag({property: 'og:url', content:  this._as.site_url+this._router.url})
  this.meta.updateTag({name: 'description',content: 'Find quality, style, and choice all in one place at Afterbricks – your gateway to premium home solutions.'})  
  }
  onDepartment(dpId: any,isHtml?:boolean) {
    this.activeDpId = dpId;
    if(isHtml){
    this.is_brand_loading = true;
    }
    let url = '';
    if (dpId) {
      url = this._as.api_base_url + 'staff/bwl/?pk=' + this.activeDpId;
    } else {
      url = this._as.api_base_url + 'staff/bwl/';
    }
  
    this._as.getRequest(url, false).subscribe((res: any) => {
      this.brand_list = [];
      this.brand_list = res.brand_list;
      this.totalBrands = res.total_found_brand
      this.global_loader = false;
      this.is_brand_loading = false;
    }, (err: any) => {
      if (err) {
        this.is_brand_loading = false;
      }
    })
  }
  branddetails(iImage: any) {
    this.selectedBrand = iImage;

    const url = this._as.api_base_url + 'oem/sub-cat-list/?brand=' + iImage.id + '&main_category=' + this.activeDpId
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.ctatype_list = res;
          if(this.ctatype_list?.length==1){
            this._router.navigate([`brand/` + this.selectedBrand.slug_name], { queryParams: { catId: this.ctatype_list[0].id } });
            return
          }
        if (res.length) {
          if (this._as.isOnMobilePlatform) {
            this.showCatTypeMobPopUp = true;

          } else {
            this.showCatTypePopUp = true;
          }
        }
        else {
          this._router.navigate([`brand/` + this.selectedBrand.slug_name]);
        }
      });

  }
  onCategoryType(ctatype: any) {
    this._router.navigate([`brand/` + this.selectedBrand.slug_name], { queryParams: { catId: ctatype.id } });
  }
}
